import { render } from "./AjudaDropdown.vue?vue&type=template&id=7ec97840"
import script from "./AjudaDropdown.vue?vue&type=script&lang=js"
export * from "./AjudaDropdown.vue?vue&type=script&lang=js"

import "./AjudaDropdown.vue?vue&type=style&index=0&id=7ec97840&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__